import { render, staticRenderFns } from "./q-image.vue?vue&type=template&id=4985879e&scoped=true&"
import script from "./q-image.vue?vue&type=script&lang=js&"
export * from "./q-image.vue?vue&type=script&lang=js&"
import style0 from "./q-image.vue?vue&type=style&index=0&id=4985879e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4985879e",
  null
  
)

export default component.exports